import aT from '../const/action-type'
import initial from '../store/initial'

export default (state = initial.calendarSearch, action) => {
  switch (action.type) {
    case aT.SET_CALENDAR_SEARCH:
      return action.data
    case aT.RESET_STORE:
      return initial.calendarSearch
    case aT.SWITCH_WORKSPACE:
      return initial.calendarSearch
    default:
      return state
  }
}
